export const REQUEST_GET_JUDGEMENTS = 'REQUEST_GET_JUDGEMENTS';
export const REQUEST_SET_JUDGEMENTS = 'REQUEST_SET_JUDGEMENTS';
